const TableSearchInput = ({
  value,
  onChange,
  placeholder = "Search...",
  onClear,
  className = "",
  inputClassName = "",
}) => {
  const handleClear = () => {
    if (onClear) {
      onClear();
      return;
    }

    onChange?.({ target: { value: "" } });
  };

  return (
    <div className={`relative w-full sm:w-96 ${className}`}>
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <i className="fi fi-rr-search text-gray-400" />
      </div>
      <input
        type="text"
        className={`block w-full rounded-lg border border-gray-200 py-2 pl-10 pr-3 transition-colors focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary ${inputClassName}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {value ? (
        <button
          type="button"
          onClick={handleClear}
          className="absolute inset-y-0 right-0 flex items-center pr-3"
          aria-label="Clear search"
        >
          <i className="fi fi-rr-cross-circle text-gray-400 hover:text-gray-600" />
        </button>
      ) : null}
    </div>
  );
};

export default TableSearchInput;
